import { useMutation } from '@tanstack/react-query'
import { cffConfigFileDownloadApi, type ExportType } from 'api-validations/pangea'

import { downloadFiles } from '../../lib'
import { useOrgCodeOrThrow } from '../active-operation'
import { useApiClient } from '../api-provider'

/**
 * Download a 2020 file representing the account configuration for the operation,
 * i.e., the client farm field structure
 */
export const useCffConfigFileDownload = () => {
  const orgCode = useOrgCodeOrThrow()
  const apiClient = useApiClient()

  return useMutation({
    mutationFn: async ({ exportType }: { exportType: ExportType }) => {
      const path = cffConfigFileDownloadApi.pathFor({ orgCode, exportType })
      const response = await apiClient.get(path)
      return cffConfigFileDownloadApi.responseSchema.parse(response.body)
    },
    onSuccess: downloadFiles
  })
}
